/**
 * Sim 9 Chase Mode's RESTART from the TV (Cole, 2026-10-14: "a controller-
 * accessible Restart" on Apple TV and LagKing TV).
 *
 * While a chase round is on, the phone publishes a one-option menu (the menu
 * mirror). The TV draws no buttons for it: the footer names the key, and the
 * key sends the phone a menu-select through sendTvCommand. The phone checks
 * the menu id and option against its own live menu before restarting, so a
 * stale press does nothing.
 *
 * Mirrored by app/LagKing/src/screens/sim9/Sim9PlayScreen.tsx; keep the ids
 * in sync.
 */
import type { TvRequestedCommand, TvSnapshot } from './protocol';

export const SIM9_CHASE_MENU_ID = 'challenge.sim9.chase';
export const SIM9_CHASE_RESTART_OPTION = 'restart';

export function chaseRestartAvailable(snapshot: TvSnapshot | null | undefined): boolean {
  const menu = snapshot?.menu;
  return menu?.id === SIM9_CHASE_MENU_ID &&
    menu.options.some((option) => option.id === SIM9_CHASE_RESTART_OPTION && !option.disabled);
}

export function chaseRestartCommand(): TvRequestedCommand {
  return { kind: 'menu-select', menuId: SIM9_CHASE_MENU_ID, optionId: SIM9_CHASE_RESTART_OPTION };
}

/** Web keyboard: R, or a TV remote's play/pause key. */
export function isChaseRestartKey(key: string): boolean {
  return key === 'r' || key === 'R' || key === 'MediaPlayPause';
}
